module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Preview")]), _vm._v(" "), _c('div', {
    staticClass: "preview-container",
    style: ({
      backgroundColor: _vm.design.background_color,
      backgroundImage: 'url(\'' + _vm.design.background_image + '\')',
      color: _vm.design.text_color
    })
  }, [_c('div', {
    staticClass: "preview-content",
    style: ({
      'font-family': _vm.design.font_family.family,
      'font-weight': _vm.design.font_weight
    })
  }, [_c('div', {
    staticClass: "preview-header",
    style: ({
      backgroundImage: 'url(\'' + _vm.design.header_image + '\')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "preview-form-instructions",
    style: ({
      color: _vm.design.text_color
    })
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.form.form_instructions) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "preview-form"
  }, [(_vm.form.fields.full_name.request) ? _c('input', {
    staticClass: "form-control margin-top-10 preview-input",
    style: ({
      backgroundColor: _vm.design.input_background_color,
      color: _vm.design.input_text_color
    }),
    attrs: {
      "type": "text",
      "placeholder": ("FULL NAME" + (_vm.form.fields.full_name.require ? '*' : ''))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.fields.email.request) ? _c('input', {
    staticClass: "form-control margin-top-10 preview-input",
    style: ({
      backgroundColor: _vm.design.input_background_color,
      color: _vm.design.input_text_color
    }),
    attrs: {
      "type": "text",
      "placeholder": ("EMAIL" + (_vm.form.fields.email.require ? '*' : ''))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.fields.phone.request) ? _c('input', {
    staticClass: "form-control margin-top-10 preview-input",
    style: ({
      backgroundColor: _vm.design.input_background_color,
      color: _vm.design.input_text_color
    }),
    attrs: {
      "type": "text",
      "placeholder": ("PHONE" + (_vm.form.fields.phone.require ? '*' : ''))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.fields.dob.request) ? _c('div', {
    staticClass: "preview-dob"
  }, [_c('p', {
    staticClass: "margin-top-20"
  }, [_vm._v("Date of Birth")]), _vm._v(" "), _c('input', {
    staticClass: "form-control margin-right-10 preview-input dob-input-style",
    style: ({
      backgroundColor: _vm.design.input_background_color,
      color: _vm.design.input_text_color
    }),
    attrs: {
      "type": "text",
      "placeholder": ("MM" + (_vm.form.fields.dob.require ? '*' : ''))
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control margin-right-10 preview-input dob-input-style",
    style: ({
      backgroundColor: _vm.design.input_background_color,
      color: _vm.design.input_text_color
    }),
    attrs: {
      "type": "text",
      "placeholder": ("DD" + (_vm.form.fields.dob.require ? '*' : ''))
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control preview-input dob-input-style",
    style: ({
      backgroundColor: _vm.design.input_background_color,
      color: _vm.design.input_text_color
    }),
    attrs: {
      "type": "text",
      "placeholder": ("YYYY" + (_vm.form.fields.dob.require ? '*' : ''))
    }
  })]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "preview-button btn default margin-top-20 full-width",
    style: ({
      backgroundColor: _vm.design.button_background_color,
      color: _vm.design.button_text_color,
      'font-weight': _vm.design.font_weight
    }),
    attrs: {
      "type": "button"
    }
  }, [_vm._v("SUBMIT")]), _vm._v(" "), _c('div', {
    staticClass: "preview-agreement"
  }, [(_vm.agreement.urls[0].url.length || _vm.agreement.urls[0].name.length || _vm.agreement.urls[1].url.length || _vm.agreement.urls[1].name.length) ? _c('p', [_vm._v("\n    \t\t\t\t\t\tI have read and agree to the "), _c('a', {
    attrs: {
      "href": _vm.agreement.urls[0].url
    }
  }, [_vm._v(_vm._s(_vm.agreement.urls[0].name || _vm.agreement.urls[0].url))]), (_vm.agreement.urls[1].url.length || _vm.agreement.urls[1].name.length) ? _c('span', [_vm._v(" and "), _c('a', {
    attrs: {
      "href": _vm.agreement.urls[1].url
    }
  }, [_vm._v(_vm._s(_vm.agreement.urls[1].name || _vm.agreement.urls[1].url))])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "preview-footer",
    style: ({
      backgroundColor: _vm.design.footer_background_color,
      borderTop: (_vm.design.footer_border_color ? ("5px solid " + (_vm.design.footer_border_color)) : 'none')
    })
  }, [(_vm.design.footer_image.length) ? _c('img', {
    attrs: {
      "src": _vm.design.footer_image
    }
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f72b3f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/UNOgames/ContestPreview.vue
// module id = 423
// module chunks = 1